export default function (instance) {
  return {
    sellCard(payload) {
      return instance.post("/activecards/sell", payload);
    },
    activateCard(cardId) {
      return instance.put("/clients/cards/activate", { card_id: cardId });
    },
    patchCard(payload) {
      return instance.put("/activecards/patch", payload);
    },
    payDebt(payload) {
      return instance.post("/activecards/paydebt", payload);
    },
    reassignCard(cardId, newClientId) {
      return instance.put(
        `/activecards/reassign/?card_id=${cardId}&client_id=${newClientId}`,
      );
    },
    deleteCard(cardId) {
      return instance.delete(`/clients/cards/delete/${cardId}`);
    },
    renewCard(cardId) {
      return instance.put(`/activecards/renew?card_id=${cardId}`);
    },
  };
}
